import { Link } from "react-router-dom";
import { X, Scales, ArrowRight } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { useCompare } from "../context/CompareContext";
import { getProviderName, getPrimarySpecialty } from "../lib/api";

const CompareBar = () => {
  const { compareList, removeFromCompare, clearCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-navy border-t border-navy/20 shadow-2xl z-50 animate-slideUp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Left: Compare items */}
          <div className="flex items-center gap-3 flex-1 overflow-x-auto">
            <div className="flex items-center gap-2 text-white shrink-0">
              <Scales className="w-5 h-5" weight="fill" />
              <span className="font-medium text-sm">Compare ({compareList.length}/3)</span>
            </div>
            
            <div className="flex items-center gap-2">
              {compareList.map((provider) => (
                <div
                  key={provider.number}
                  className="flex items-center gap-2 bg-white/10 rounded-lg px-3 py-2 text-white text-sm"
                  data-testid={`compare-item-${provider.number}`}
                >
                  <div className="max-w-[150px] truncate">
                    <span className="font-medium">{getProviderName(provider)}</span>
                    <span className="text-white/60 text-xs block truncate">
                      {getPrimarySpecialty(provider)}
                    </span>
                  </div>
                  <button
                    onClick={() => removeFromCompare(provider.number)}
                    className="text-white/60 hover:text-white p-1 rounded-full hover:bg-white/10"
                    aria-label="Remove from compare"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ))}
              
              {/* Empty slots */}
              {[...Array(3 - compareList.length)].map((_, i) => (
                <div
                  key={`empty-${i}`}
                  className="w-[180px] h-[52px] border border-dashed border-white/30 rounded-lg flex items-center justify-center text-white/40 text-xs"
                >
                  + Add provider
                </div>
              ))}
            </div>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={clearCompare}
              className="text-white/60 hover:text-white text-sm font-medium"
            >
              Clear all
            </button>
            
            <Link to="/compare">
              <Button
                disabled={compareList.length < 2}
                className="bg-teal hover:bg-teal/90 text-white gap-2"
                data-testid="compare-button"
              >
                Compare Now
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
